module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Sign-out-edde73099a731d715041b2e1336fa42a.svg";